function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo, useState, createElement as _createElement } from 'react';
import { makeStyles, MenuList } from '@material-ui/core';
import cn from 'classnames';
import colors from "../../foundations/colors.module.scss";
import { openInNewTabProps } from "../../utils/externalLinks";
import { getTestIds } from "../../utils/TestIds";
import { useStateInRef } from "../../utils/useStateInRef";
import { Badge } from "../Badge";
import { CircularLoader } from "../CircularLoader";
import { Column, Row } from "../Layout";
import { MenuItem } from "../MenuItem";
import { Searchbox } from "../Searchbox";
import { Typography } from "../Typography";
import styles from "./Menu.module.scss";
import { MenuContextualAction } from "./MenuContextualAction";
import { MenuPromotionalAction } from "./MenuPromotionalAction/MenuPromotionalAction";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useMenuListStyles = makeStyles({
  root: {
    paddingTop: 4,
    flex: 1,
    overflow: 'auto',
    outline: 'none',
    touchAction: 'pan-y'
  },
  sectionHeader: {
    '&.Mui-disabled': {
      opacity: 1,
      color: "".concat(colors.dark700, " !important"),
      margin: '0 1px'
    }
  },
  item: {
    '&.Mui-disabled': {
      '& *': {
        color: 'inherit !important'
      }
    }
  }
});
export const GetMenuTID = parentTestId => getTestIds(parentTestId);
export function Menu(props) {
  const {
    testId,
    loading,
    searchProps,
    footer,
    items,
    emptyText,
    dimensions,
    classes,
    menuListRef
  } = props;
  const menuListClasses = useMenuListStyles();
  const footerItems = (footer === null || footer === void 0 ? void 0 : footer.items) || [];
  const {
    showSearch,
    strategy,
    autoFocus
  } = searchProps || {};
  const {
    height = 'auto',
    width = 400,
    minHeight = 80,
    maxHeight = 500,
    minWidth,
    maxWidth,
    paddingBottom,
    paddingTop
  } = dimensions || {};
  const {
    MenuTID
  } = useMemo(() => GetMenuTID(testId), [testId]);
  const [search, setSearch] = useState('');
  const getStrategy = useStateInRef(strategy);
  const [autoFocusItem, setAutoFocusItem] = useState(false);
  useEffect(() => {
    if (autoFocusItem) {
      setAutoFocusItem(false);
    }
  }, [autoFocusItem]);
  const filteredItems = useMemo(() => {
    const strategy = getStrategy();
    if (!showSearch || !strategy) {
      return items;
    }
    const filtered = items.filter(item => {
      if (item.isSectionHeader) {
        return true;
      }
      switch (strategy.type) {
        case 'text':
          {
            const trimmedSearch = search.trim().toLowerCase();
            return typeof item.title === 'string' && item.title.toLowerCase().includes(trimmedSearch);
          }
        case 'custom':
          return strategy.filterItem(search, item);
      }
    });
    return keepOnlyHeadersWithItems(filtered);
  }, [items, showSearch, search]);
  function keepOnlyHeadersWithItems(items) {
    const result = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (!item.isSectionHeader) {
        result.push(item);
        continue;
      }
      const nextItem = items[i + 1];
      if (nextItem && !nextItem.isSectionHeader) {
        result.push(item);
      }
    }
    return result;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, classes === null || classes === void 0 ? void 0 : classes.root),
    "data-testid": MenuTID.Root(),
    style: {
      height,
      width,
      minHeight,
      maxHeight,
      minWidth,
      maxWidth,
      paddingBottom,
      paddingTop
    },
    children: [showSearch && /*#__PURE__*/_jsx("div", {
      className: styles.searchSection,
      children: /*#__PURE__*/_jsx(Searchbox, {
        variant: "textfield",
        fluidWidth: true,
        autoFocus: autoFocus,
        "data-testid": MenuTID.Search(),
        value: search,
        onChange: e => setSearch(e.target.value),
        onClear: () => setSearch(''),
        onKeyDown: e => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            setAutoFocusItem(true);
          }
        }
      })
    }), /*#__PURE__*/_jsx(MenuList, {
      disablePadding: true,
      autoFocusItem: autoFocusItem,
      classes: {
        root: cn(menuListClasses.root, classes === null || classes === void 0 ? void 0 : classes.menuList)
      },
      ref: menuListRef,
      children: loading ? /*#__PURE__*/_jsx("li", {
        className: styles.loading,
        children: /*#__PURE__*/_jsx(CircularLoader, {
          "data-testid": MenuTID.Loading()
        })
      }) : filteredItems.length > 0 ? filteredItems.map((item, index) => {
        var _item$testId2;
        if (item.isSectionHeader) {
          var _item$testId;
          return /*#__PURE__*/_jsx(MenuItem, {
            disabled: true,
            className: styles.sectionHeader,
            classes: {
              root: menuListClasses.sectionHeader
            },
            "data-testid": (_item$testId = item.testId) !== null && _item$testId !== void 0 ? _item$testId : item.id,
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph1",
              weight: "normal",
              children: item.label
            })
          }, item.id);
        }
        return /*#__PURE__*/_jsx(MenuItem, {
          variant: "multiline",
          "data-testid": (_item$testId2 = item.testId) !== null && _item$testId2 !== void 0 ? _item$testId2 : MenuTID.Item(index),
          className: cn(styles.item, menuListClasses.item),
          onClick: item.onClick,
          disabled: item.disabled,
          intent: item.intent,
          selected: item.selected,
          style: item.tooltip && item.disabled ? {
            pointerEvents: 'auto'
          } : undefined,
          tooltipProps: {
            title: item.tooltip || '',
            placement: 'top-start',
            centerArrow: true
          },
          children: /*#__PURE__*/_jsxs(Row, _objectSpread(_objectSpread({
            alignItems: "center",
            gap: 8
          }, item.externalLink ? _objectSpread({
            as: 'a',
            href: item.externalLink.href
          }, item.externalLink.openInNewTab ? openInNewTabProps : {}) : {}), {}, {
            children: [item.prefixIcon && /*#__PURE__*/_jsx("div", {
              className: styles.noShrink,
              children: item.prefixIcon
            }), /*#__PURE__*/_jsxs(Column, {
              width: "100%",
              children: [item.title && /*#__PURE__*/_jsxs(Row, {
                gap: 4,
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph1",
                  ellipsis: true,
                  weight: "normal",
                  skin: "secondary",
                  className: styles.changeTextColorOnHover,
                  "data-testid": MenuTID.ItemTitle(index),
                  children: item.title
                }), item.badge && /*#__PURE__*/_jsx(Badge, {
                  outlined: true,
                  rounded: true,
                  skin: "primary",
                  "data-testid": MenuTID.ItemBadge(index),
                  children: item.badge.text
                })]
              }), item.body && /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph1",
                skin: "secondary",
                weight: "light",
                className: styles.changeTextColorOnHover,
                "data-testid": MenuTID.ItemBody(index),
                children: item.body
              }), item.subtext && /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                className: styles.changeTextColorOnHover,
                "data-testid": MenuTID.ItemSubtext(index),
                children: item.subtext
              })]
            }), item.suffixIcon && /*#__PURE__*/_jsx("div", {
              className: styles.noShrink,
              children: item.suffixIcon
            })]
          }))
        }, item.id);
      }) : /*#__PURE__*/_jsx(MenuItem, {
        disabled: true,
        className: styles.emptyText,
        "data-testid": MenuTID.Empty(),
        children: emptyText
      })
    }), footerItems.length > 0 && /*#__PURE__*/_jsx("div", {
      className: footer === null || footer === void 0 ? void 0 : footer.className,
      children: footerItems.map((item, index) => {
        switch (item.variant) {
          case 'contextualAction':
            return /*#__PURE__*/_createElement(MenuContextualAction, _objectSpread(_objectSpread({}, item.props), {}, {
              key: index
            }));
          case 'promotionalAction':
            return /*#__PURE__*/_createElement(MenuPromotionalAction, _objectSpread(_objectSpread({}, item.props), {}, {
              key: index
            }));
        }
      })
    })]
  });
}